import UsersListing from './UsersListing';

export default UsersListing;
